let language = {
    BULK_ORDER_CHECKOUT_STEP_BULK_ITEM_NULL: "bulkOrder is null!"
};

export { language }